import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  Typography,
  Box,
} from "@mui/material";

// Importing images
import products from "../../assets/img/products.png";
import dashboard from "../../assets/img/dashboard.png";
import manage_order from "../../assets/img/manage_order.png";
import customer from "../../assets/img/customer.png";
import transaction from "../../assets/img/transaction.png";
import cross from "../../assets/img/cross.png";

const MENU_ITEMS = [
  {
    path: "/Dashboard",
    label: "Dashboard",
    icon: dashboard,
  },
  {
    path: "/ProductDashboard",
    label: "Products",
    icon: products,
  },
  {
    path: "/OrderDashboard",
    label: "Manage Orders",
    icon: manage_order,
  },
  {
    path: "/CustomerDashboard",
    label: "Customers",
    icon: customer,
  },
  {
    path: "/TransactionDashboard",
    label: "Transactions",
    icon: transaction,
  },
  {
    path: "/DeliveryPerson",
    label: "Delivery person",
    icon: customer,
  },
  {
    path: "/areas",
    label: "Manage areas",
    icon: manage_order,
  },
];

const NavItem = ({ path, label, icon, isActive, onClick }) => {
  const theme = useTheme();
  
  return (
    <ListItem
      component="div"
      onClick={onClick}
      sx={{
        backgroundColor: isActive 
          ? theme.palette.primary.main 
          : theme.palette.primary.light,
        color: "#fff",
        borderBottom: "1px solid #1976D2",
        marginTop: "1px",
        cursor: "pointer",
        padding: "15px",
        "&:hover": {
          backgroundColor: theme.palette.primary.light,
        },
      }}
    >
      <ListItemIcon>
        <img
          src={icon}
          alt={label}
          style={{ width: 28, height: 24 }}
        />
      </ListItemIcon>
      <ListItemText primary={label} />
    </ListItem>
  );
};

const Sidebar = ({ toggleSidebar }) => {
  const theme = useTheme();
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const storedUser = localStorage.getItem("pd");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setIsUserLoggedIn(true);
      setUserName(parsedUser.user?.name || "User");
    }
  }, []);

  if (!isUserLoggedIn) return null;

  const handleNavigation = (path) => {
    navigate(path);
    toggleSidebar();
  };

  return (
    <Box
      component="nav"
      sx={{
        width: 280,
        backgroundColor: "#FFF",
        height: "100vh",
        color: "#fff",
      }}
    >
      <Box
        sx={{
          padding: "1.2rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: theme.palette.primary.main,
        }}
      >
        <Avatar
          sx={{
            bgcolor: "#ffffff",
            color: "#1976D2",
            width: 50,
            height: 50,
            fontSize: "1.5rem",
          }}
        >
          {userName.charAt(0).toUpperCase()}
        </Avatar>

        <Typography
          variant="subtitle1"
          noWrap
          sx={{
            fontSize: "1.2rem",
            fontWeight: 500,
          }}
        >
          {userName.slice(0, 10)}
        </Typography>

        <Box
          component="img"
          src={cross}
          alt="Close Sidebar"
          onClick={toggleSidebar}
          sx={{
            width: 30,
            height: 30,
            cursor: "pointer",
          }}
        />
      </Box>

      <List
        component="nav"
        sx={{
          padding: 0,
          gap: "10px",
          display: "flex",
          flexDirection: "column",
          margin: "20px",
        }}
      >
        {MENU_ITEMS.map((item) => (
          <NavItem
            key={item.path}
            {...item}
            isActive={location.pathname === item.path}
            onClick={() => handleNavigation(item.path)}
          />
        ))}
      </List>
    </Box>
  );
};

export default Sidebar;